
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.0001 12C12.0001 9 14.5001 6.5 17.5001 6.5C20.0701 6.5 22.2701 8.33 22.8501 10.74C23.0001 11.38 22.5301 12 21.8801 12H12.0001ZM12.0001 12C12.0001 15 9.50012 17.5 6.50012 17.5C3.93012 17.5 1.73012 15.67 1.15012 13.26C1.00012 12.62 1.47012 12 2.12012 12H12.0001ZM12.0001 12C9.00012 12 6.50012 9.5 6.50012 6.5C6.50012 3.93 8.33012 1.73 10.7401 1.15C11.3801 1 12.0001 1.47 12.0001 2.12V12ZM12.0001 12C15.0001 12 17.5001 14.5 17.5001 17.5C17.5001 20.07 15.6701 22.27 13.2601 22.85C12.6201 23 12.0001 22.53 12.0001 21.88V12Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-toys`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconToys

    ```js
    <b-new-b-icon-toys />
    ```
</docs>


